import React, { useState } from "react"
import MetaTags from "react-meta-tags"
import {
  Col,
  Container,
  Row,
} from "reactstrap"

import ServiceStructure from "../../components/Services/structure/ServiceStructure"

const NoObjectionLetter = () => {
  const [menu, setMenu] = useState(false)
  const toggle = () => {
    setMenu(!menu)
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>No-Objection | REMA</title>
        </MetaTags>
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={12}>
                <h6 className="page-title">
                  Request for non-objection letter
                </h6>

                <ServiceStructure
                  disablePayableFee={true}
                  disableLicenseValidity={true}
                  detailsType="no-objection"
                  url="no-objection-letter-apply"
                  serviceType="Request for non-objection letter"
                  department="Advocacy & Multilateral Environment Agreement Monitoring Unit (AMEAMU)"
                />
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default NoObjectionLetter
